<template>
  <router-view />
</template>
<script>
export default {
  name: 'Horizon',
};
</script>
